// extracted by mini-css-extract-plugin
export default {"Avator":"Opportunity_Avator__o6ubW"};